<script lang="ts">
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';
	import { isLoadingStore } from '$lib/stores/loading';
	
	$:if ($isLoadingStore) {
		console.log('🔄 Showing preloader...');
	} else {
		console.log('✅ Hiding preloader...');
	}
	
	onMount(() => {
		// 🔧 แก้ไขปัญหาค้าง: ใช้ multiple fallbacks
		const hidePreloader = () => {
			console.log('🔄 Hiding preloader...');
			isLoadingStore.set(false);
		};
		
		isLoadingStore.set(true);
		// 1. ⏰ Time-based fallback (ป้องกันค้างแน่นอน)
		const timeoutFallback = setTimeout(hidePreloader, 10000); // 3 วินาที max
		
		// 2. 📄 Document ready state
		if (browser) {
			if (document.readyState === 'complete') {
				// หน้าโหลดเสร็จแล้ว - ซ่อนเลย
				setTimeout(hidePreloader, 500);
				clearTimeout(timeoutFallback);
			} else {
				// รอให้หน้าโหลดเสร็จ
				const handleLoad = () => {
					setTimeout(hidePreloader, 500);
					clearTimeout(timeoutFallback);
					window.removeEventListener('load', handleLoad);
				};
				window.addEventListener('load', handleLoad);
				
				// 3. 🖼️ รอให้รูปภาพโหลดเสร็จ (ถ้ามี)
				const images = document.querySelectorAll('img');
				let loadedImages = 0;
				const totalImages = images.length;
				
				if (totalImages === 0) {
					// ไม่มีรูป - ซ่อนเลย
					setTimeout(hidePreloader, 800);
					clearTimeout(timeoutFallback);
				} else {
					images.forEach((img) => {
						if (img.complete) {
							loadedImages++;
						} else {
							img.addEventListener('load', () => {
								loadedImages++;
								if (loadedImages === totalImages) {
									setTimeout(hidePreloader, 500);
									clearTimeout(timeoutFallback);
								}
							});
							img.addEventListener('error', () => {
								loadedImages++;
								if (loadedImages === totalImages) {
									setTimeout(hidePreloader, 500);
									clearTimeout(timeoutFallback);
								}
							});
						}
					});
				}
			}
		} else {
			// Server-side - ซ่อนเลย
			isLoadingStore.set(false);
		}
		
		// 🧹 Cleanup
		return () => {
			clearTimeout(timeoutFallback);
		};
	});
</script>

{#if $isLoadingStore}
	<div id="preloader" class="svelte-preloader">
		<div class="loader"></div>
	</div>
{/if}

<style>
	.svelte-preloader {
		background-color: #0a0a0a;
		height: 100vh;
		width: 100vw;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: opacity 0.5s ease-out;
		opacity: 0.4;
	}
	
	.loader {
		width: 60px;
		display: flex;
		align-items: flex-start;
		aspect-ratio: 1;
	}
	
	.loader::before,
	.loader::after {
		content: "";
		flex: 1;
		aspect-ratio: 1;
		--g: conic-gradient(from -90deg at 10px 10px, #4b59f5 90deg, #0000 0);
		background: var(--g), var(--g), var(--g);
		filter: drop-shadow(30px 30px 0 #4b59f5);
		animation: spin 1s infinite;
	}
	
	.loader::after {
		transform: scaleX(-1);
	}
	
	@keyframes spin {
		0% {
			background-position: 0 0, 10px 10px, 20px 20px;
		}
		33% {
			background-position: 10px 10px, 20px 20px, 30px 30px;
		}
		66% {
			background-position: 20px 20px, 30px 30px, 40px 40px;
		}
		100% {
			background-position: 30px 30px, 40px 40px, 50px 50px;
		}
	}
</style>
